import { render } from "./InfiniteListWrapper.vue?vue&type=template&id=549a99e0&scoped=true&ts=true"
import script from "./InfiniteListWrapper.vue?vue&type=script&lang=ts"
export * from "./InfiniteListWrapper.vue?vue&type=script&lang=ts"

import "./InfiniteListWrapper.vue?vue&type=style&index=0&id=549a99e0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549a99e0"]])

export default __exports__